import dayjs from 'dayjs';

export function buildAvailableDates(calendarDay: string): string[] {
    const start = dayjs(calendarDay);
    return Array.from({ length: 5 }, (_, i) => start.add(i, 'day').format('YYYY-MM-DD'));
}

type Translate = (key: string, values?: { date: string }) => string;

export function resolveTimedDateLabel(args: {
    date: string;
    calendarDay: string;
    localeDate: string;
    t: Translate;
}): string {
    const { date, calendarDay, localeDate, t } = args;
    if (date === calendarDay) {
        return t('CART_TIMED_ORDERS_BOX.TODAY_DATE', { date: localeDate });
    }
    if (date === dayjs(calendarDay).add(1, 'day').format('YYYY-MM-DD')) {
        return t('CART_TIMED_ORDERS_BOX.TOMORROW_DATE', { date: localeDate });
    }
    return localeDate;
}

export function resolveStaleTimedSelection(args: {
    date: string | undefined;
    timeStart: string | null | undefined;
    availableDates: string[];
    calendarDay: string;
}): { date: string; timeStart: string | undefined } {
    const { date, timeStart, availableDates, calendarDay } = args;
    if (date && availableDates.includes(date)) {
        return { date, timeStart: timeStart ?? undefined };
    }
    return { date: calendarDay, timeStart: undefined };
}

/** Keep timeStart only when it still exists among the day's slot starts (`HH:mm`). */
export function resolveTimedSlotSelection(args: {
    timeStart: string | null | undefined;
    slotStarts: string[];
}): string | undefined {
    const { timeStart, slotStarts } = args;
    if (!timeStart) {
        return undefined;
    }
    return slotStarts.includes(timeStart) ? timeStart : undefined;
}
